import { LockOutlined } from "@mui/icons-material";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import React from "react";
import { SubscriptionInfo } from "../../../../@types/subscriptionInfo";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  adressFormatter,
  documentNumberFormatter,
} from "../../../../services/UtilsService";

interface ItemProps {
  children: React.ReactNode;
}

const Item: React.FC<ItemProps> = ({ children }) => {
  return (
    <Box display={"flex"} justifyContent={"space-between"} padding={2}>
      {children}
    </Box>
  );
};

const BusinessInformation: React.FC = () => {
  const subscription = useAppSelector<SubscriptionInfo | undefined>(
    (state) => state.subscriptionSlice.subscription
  );

  if (!subscription) return <></>;

  return (
    <Box>
      <Typography color={"typography.secondary"} variant="h3" paddingY={2}>
        Dados da empresa
      </Typography>

      <Box
        display={"flex-column"}
        gap={2}
        sx={{
          border: "1px solid grey",
          borderRadius: "8px",
          borderColor: "#E9EBF0",
        }}
      >
        <Item>
          <Box>
            <Typography variant="body1">CNPJ</Typography>
            <Typography variant="caption" color={"typography.secondary"}>
              {documentNumberFormatter(subscription.ownerPerson.documentNumber)}
            </Typography>
          </Box>

          <Box>
            <IconButton disabled>
              <LockOutlined />
            </IconButton>
          </Box>
        </Item>
        <Divider />
        <Item>
          <Box>
            <Typography variant="body1">Razão social</Typography>
            <Typography variant="caption" color={"typography.secondary"}>
              {subscription.ownerPerson.name}
            </Typography>
          </Box>

          <IconButton disabled>
            <LockOutlined />
          </IconButton>
        </Item>
        <Divider />
        <Item>
          <Box>
            <Typography variant="body1">Endereço</Typography>
            {subscription?.ownerPerson?.address?.address ? (
              <Typography variant="caption" color={"typography.secondary"}>
                {adressFormatter(subscription?.ownerPerson?.address)}
              </Typography>
            ) : (
              <Typography variant="caption" color={"typography.secondary"}>
                Endereço não cadastrado
              </Typography>
            )}
          </Box>

          <Box>
            <IconButton disabled>
              <LockOutlined />
            </IconButton>
          </Box>
        </Item>
        <Divider />
        <Item>
          <Box>
            <Typography variant="body1">
              Sócios e representantes legais
            </Typography>
            {subscription?.ownerPerson?.relationships.length ? (
              <Typography variant="caption" color={"typography.secondary"}>
                {subscription?.ownerPerson?.relationships.map(
                  (relationship, index) => {
                    return (
                      <>
                        {index > 0 && ", "}
                        {relationship.name}
                      </>
                    );
                  }
                )}
              </Typography>
            ) : (
              <Typography variant="caption" color={"typography.secondary"}>
                Nenhum sócio cadastrado
              </Typography>
            )}
          </Box>

          <Box>
            <IconButton disabled>
              <LockOutlined />
            </IconButton>
          </Box>
        </Item>
        <Divider />
      </Box>
    </Box>
  );
};

export default BusinessInformation;
